import { useMediaQuery } from '@material-ui/core';

const useDesktop = () =>
  useMediaQuery((theme) => theme.breakpoints.up('md'), { noSsr: true });

export default useDesktop;
